import { __assign } from 'tslib';
import React__default, { useContext } from 'react';
import { isEmpty } from 'lodash';
import { UserAuthContext } from '@invitae/cms-blocks';
import { CartContextWrapper } from '@invitae/header-footer';

var CartProvider = function (_a) {
    var children = _a.children, cartConfig = _a.cartConfig, nucleobaseConfig = _a.nucleobaseConfig, contentfulConfig = _a.contentfulConfig;
    var isUserAuthenticated = useContext(UserAuthContext).isUserAuthenticated;
    if (!cartConfig || isEmpty(cartConfig))
        return React__default.createElement(React__default.Fragment, null, children);
    if (cartConfig && (!nucleobaseConfig || isEmpty(nucleobaseConfig))) {
        console.error("CartProvider - Missing `nucleobaseConfig` in NucleobaseShell. \n You can't use Cart in navigation without `nucleobaseConfig`.");
        return React__default.createElement(React__default.Fragment, null, children);
    }
    if (cartConfig && !contentfulConfig) {
        console.error("CartProvider - Missing `contentfulConfig` in NucleobaseShell. \n You can't use Cart in navigation without defining `contentfulConfig` for navigation.");
        return React__default.createElement(React__default.Fragment, null, children);
    }
    return (React__default.createElement(CartContextWrapper, __assign({}, cartConfig, { isUserAuthenticated: isUserAuthenticated }), children));
};

export { CartProvider as default };
//# sourceMappingURL=CartProvider.esm.js.map
